"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var urlContext;
var messages;
var locale;
var reactDomContainerSelector;
exports.IS_SSR = typeof window === 'undefined';
exports.DEFAULT_LOCALE = 'en';
exports.DEFAULT_MESSAGES = {
    default_error_message: 'The request cannot be processed. Try again later.',
};
var LOGGER_PREFIX = 'sonar-ui-common init:';
exports.default = {
    setUrlContext: function (newUrlContext) {
        urlContext = newUrlContext;
        return this;
    },
    setLocale: function (newLocale) {
        locale = newLocale;
        return this;
    },
    setMessages: function (newMessages) {
        messages = newMessages;
        return this;
    },
    setReactDomContainer: function (nodeSelector) {
        reactDomContainerSelector = nodeSelector;
        return this;
    },
};
function getMessages() {
    if (typeof messages === 'undefined') {
        logWarning('L10n messages are not initialized. Use default messages.');
        return exports.DEFAULT_MESSAGES;
    }
    return messages;
}
exports.getMessages = getMessages;
function getLocale() {
    if (typeof locale === 'undefined') {
        logWarning('L10n locale is not initialized. Use default locale.');
        return exports.DEFAULT_LOCALE;
    }
    return locale;
}
exports.getLocale = getLocale;
function getReactDomContainerSelector() {
    return reactDomContainerSelector || '#content';
}
exports.getReactDomContainerSelector = getReactDomContainerSelector;
function getUrlContext() {
    if (typeof urlContext === 'undefined') {
        throw new Error(LOGGER_PREFIX + " web context needs to be initialized by Initializer.setUrlContext before being used");
    }
    return urlContext;
}
exports.getUrlContext = getUrlContext;
function logWarning(message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(LOGGER_PREFIX + " " + message);
    }
}
//# sourceMappingURL=init.js.map